/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

const TableHeader = ({ sortConfig, handleSort }) => {
  const { t: tr } = useTranslation();
  const getSortIcon = (column) => {
    if (sortConfig.key === column) {
      return sortConfig.direction === "ascending" ? "▲" : "▼";
    }
    return <span style={{ visibility: "hidden" }}>▲</span>;
  };

  return (
    <div className="row table-header report text-center align-items-center">
      <div className="col-sm report-expand report-expand ml-3">
        <div className="row">
          <div className="report-expand-column" />
          <div className="report-expand-column" />
        </div>
      </div>
      <div
        className="col-sm report-date-col sortable-column"
        onClick={() => handleSort("date")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:date_8")} {getSortIcon("date")}</span>
      </div>
      <div
        className="col-sm sortable-column report-weekday-col"
        onClick={() => handleSort("dayOfWeek")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("billing:weekday_131")} {getSortIcon("dayOfWeek")}
        </span>
      </div>
      <div
        className="col-sm report-start-time-col sortable-column"
        onClick={() => handleSort("startTime")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("calendar:time")} {getSortIcon("startTime")}
        </span>
      </div>
      <div
        className="col-sm sortable-column report-lesson-type-col"
        onClick={() => handleSort("classType")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:lessonType_196")} {getSortIcon("classType")}
        </span>
      </div>
      <div
        className="col-sm sortable-column report-student-col"
        onClick={() => handleSort("studentName")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:student_14")} {getSortIcon("studentName")}
        </span>
      </div>
      <div
        className="col-sm sortable-column report-client-col"
        onClick={() => handleSort("clientName")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:client_108")} {getSortIcon("clientName")}
        </span>
      </div>
      <div
        className="col-sm sortable-column report-teacher-col"
        onClick={() => handleSort("teacherName")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:teacher_226")} {getSortIcon("teacherName")}
        </span>
      </div>

      <div
        className="col-sm align-items-center report-checkbox report-present-col sortable-column"
        onClick={() => handleSort("isPresent")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("client:present_31")} {getSortIcon("isPresent")}
        </span>
      </div>
      <div
        className="col-sm report-comment-col sortable-column flex-grow-1"
        onClick={() => handleSort("comment")}
        role="columnheader"
        tabIndex={0}
      >
        <span className="text-with-icon">{tr("manage:notes_10")} {getSortIcon("comment")}
        </span>
      </div>
    </div>
  );
};

TableHeader.propTypes = {
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  handleSort: PropTypes.func.isRequired,
};

export default TableHeader;
